import { QUERY_PARAM_SORT, QUERY_PARAM_PAGE, QUERY_PARAM_MODAL, QUERY_PARAM_LOCATION } from './filter-keys';

export default [
    QUERY_PARAM_SORT,
    QUERY_PARAM_PAGE,
    QUERY_PARAM_MODAL,
    QUERY_PARAM_LOCATION
];
